import React from 'react'

import { SiteStore } from '~context/siteContext'
import refreshPreview from '~utils/refreshPreview'

const isDev = process.env.NODE_ENV === 'development'

export const wrapRootElement = ({ element }) => (
	<SiteStore>{element}</SiteStore>
)

const transitionDelay = 0
export const shouldUpdateScroll = ({
	routerProps: { location },
	getSavedScrollPosition,
}) => {
	// first check if the route change is just a filter change
	const isFilterChange = ['/articles/', '/articles', '/stories/', '/stories'].includes(location.pathname) && location.search.length > 0
	if(isFilterChange){
		return false
	}
	if(location.state?.disableScrollUpdate === true){
		const { disableScrollUpdate } = location.state
		return !disableScrollUpdate
	}
	window.history.scrollRestoration = 'manual'
	const currentPosition = getSavedScrollPosition(location)
	window.setTimeout(() => {
		if(!location.hash){
			window.scrollTo(...currentPosition)
		}
	}, transitionDelay )
	return false
}


export const onClientEntry = () => {
	// refresh the preview on hard reload
	if(isDev){
		refreshPreview()
	}

	// stop safari from loaded cached page state on back button
	(function () {
		window.onpageshow = function(event) {
			if (event.persisted) {
				window.location.reload()
			}
		}
	})()

}
